import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Toolbar,
  Typography,
  FormControl,
  Link,
  Select,
  useMediaQuery,
  IconButton 
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import { styled, useTheme } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import partnerLogo from "../../Assets/CompanyImg/partner.png";
import dashlogo from "../../Assets/CompanyImg/Dasboard.png";
import SpeedIcon from "@mui/icons-material/Speed";
import vehiclelogo from "../../Assets/CompanyImg/vehicle.png";
import Logo from "../../Assets/Images/logo.png";
import SettingsIcon from "@mui/icons-material/Settings";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EditIcon from '@mui/icons-material/Edit';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupIcon from '@mui/icons-material/Group';
import LockIcon from '@mui/icons-material/Lock';
import PeopleIcon from "@mui/icons-material/People";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import EuroIcon from '@mui/icons-material/Euro';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CommuteIcon from '@mui/icons-material/Commute';
import FunctionsIcon from '@mui/icons-material/Functions';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import { resetContact } from "../../redux/reducers/contactReducer";
import { resetHomeRe } from "../../redux/reducers/homeReducer";
import { paths } from "../../config/constants";
import { useDispatch,useSelector } from "react-redux";
import { reset } from "../../redux/reducers/login";
import { authToken } from "../../redux/reducers/login";
import BussinessBooking from "./bussinessBooking";
import ReceiptLongIcon  from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';

import axios from "axios";


const drawerWidth = 240;

// 🔧 Permanent Drawer Styling (Desktop + iPad)
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "openDrawer",
})(({ theme, openDrawer }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(openDrawer && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!openDrawer && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function CompanyLayout() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:775px)");
  const [openDrawer, setOpenDrawer] = useState(true); // Desktop drawer state
  const [mobileOpen, setMobileOpen] = useState(false); // Mobile drawer state
   const [paymentDetail, setPaymentDetail] = useState('Driver Payment');
  const [partner, setPartner] = React.useState("part");
  // const loginRole = useSelector(authToken);
  // const loginRoles = loginRole.payload.login.user.data.role
  const reduxdata = useSelector((state) => state);
  const userId = reduxdata?.login?.user?.data?._id;
    let token = reduxdata?.login?.token;
      let toastId1;
      let toastId2;
      let toastId3;

  console.log("userID",userId)
  const dispatch = useDispatch();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [vehicle, setVehicle] = useState("vehicle1");
  const [zone, setZone] = useState("zone");
  const [price, setPrice] = useState("price");
  const [extraOptions, setExtraOptions] = useState(" ");
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);
  const [bankInvoicelimit, setBankInvoiceLimit] = useState(0);
  const [isComissionNull,setIsComissionNull] = useState(null)
  const [accountType, setAccountType] = useState(null);
  const [role,setRole]=useState(null)
  const [invoiceHistory, setInvoiceHistory] = useState('Invoices');


  const handleChangeVehicle = (event) => {
    setVehicle(event.target.value);
  };

  const handleChangePartner = (event) => {
    setPartner(event.target.value);
  };

  useEffect(() => {
      if (token) {
        const storedTokenTimestamp = localStorage.getItem('tokenTimestamp');
        const currentTime = Date.now();
        const storedTimestamp = parseInt(storedTokenTimestamp, 10);
        const tokenExpirationTime = 1800000;
        if (currentTime - storedTimestamp >= tokenExpirationTime) {
          handleExpire();
        }
      }
    }, [token]);
  
  
    const handleExpire = () => {
  
      toast.error("Session Expired!",{autoClose: 2500});
      dispatch(resetContact());
      dispatch(resetHomeRe());
      dispatch(reset());
      sessionStorage.clear();
      // localStorage.clear();
      navigate(paths.accounts.login);
      toast.success("Logout Successfully! ",{autoClose: 2500});
  
    }

  const handleLogout = () => {
    dispatch(resetContact());
    dispatch(resetHomeRe());
    dispatch(reset());
    sessionStorage.clear();
    localStorage.clear();
    toast.success("Logout Successfully");
    navigate(paths.accounts.login);
  };

  const handleSelectChange = (e) => {
    const newValue = e.target.value;
    setPaymentDetail(newValue);
  };

  const handleMenuItemClick = (value) => {
    navigate(`${paths.company.paymentdetail}?paymentType=${value}`);
  };
  
  const fetchData = async () => {
    let obj = {
      userId: userId,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/getUserProfile`,
        obj
      );
      console.log(res?.data?.data);
      setIsProfileCompleted(res?.data?.data?.isProfileCompleted);
      setBankInvoiceLimit(res?.data?.data?.companyAgentLimit)
      setIsComissionNull(res?.data?.data?.companyAgentComission);
      setAccountType(res?.data?.data?.accountType);
      setRole(res?.data?.data?.role);
      console.log("aio")
    } catch (error) {}
  };

  useEffect(() => {
      fetchData();
    }, []);

const handleBookingClick = () => {
    if (!isProfileCompleted) {
      toast.warn("Please complete your profile first ❗");
    } else {
      navigate(paths.company.companybooking);
    }
  };

  // Drawer Content (shared)
  const drawerContent = (
    <div>
      <Box display="flex" justifyContent="center" alignItems="center" p={2}>
        <img src={Logo} alt="logo" width="100%" />
      </Box>
      <Divider />
      <List>
                 <ListItem disablePadding sx={{ display: "block" }}>
                {/* <NavLink to={paths.company.dashboard} className="sidelink"> */}
                  <NavLink
                      to={
                        accountType === "Company" && role === "2"
                          ? paths.company.dashboard
                          : accountType === "Agent" && role === "2"
                          ? paths.businessAgent.dashboard
                          : "#" // fallback in case neither condition matches
                      }
                      className="sidelink"
                    >
                    <ListItemButton
                      spacing={4}
                      sx={{
                        minHeight: 48,
                        justifyContent: openDrawer ? "initial" : "center",
                        px: 2.5,
                        color: "white",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: openDrawer ? 3 : "auto",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                        <SpeedIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography className="companySidebarTextSize">
                          {" "}
                          Dashboard
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </NavLink>
                </ListItem>

                
                  <ListItem disablePadding sx={{ display: "block" }}>
                    {/* <NavLink to={paths.company.BussinessBooking} className="sidelink"> */}
                    <NavLink
                      to={
                        accountType === "Company" && role === "2"
                          ? paths.company.BussinessBooking
                          : accountType === "Agent" && role === "2"
                          ? paths.businessAgent.BussinessBooking
                          : "#" // fallback in case neither condition matches
                      }
                      className="sidelink"
                    >
                      <ListItemButton
                      onClick={(e) => {
                        if (isProfileCompleted === false) {
                          e.preventDefault(); // stop any default behavior
                           if (!toast.isActive(toastId1)) {
                            toastId1 = toast.info(
                            "You cannot book right now because your profile is incomplete.",
                            { autoClose: 2500 }
                              );
                            }
                          return; // stop further execution
                        }
                         else if (isComissionNull === null || !isComissionNull) {
                          e.preventDefault(); // stop any default behavior
                           if (!toast.isActive(toastId2)) {
                            toastId2 = toast.info(
                            "You cannot book right now because your commission has not yet been set. Contact customer support.",
                            { autoClose: 2500 }
                              );
                            }
                          return; // stop further execution
                        }

                        // Otherwise, allow normal behavior (if you have any)
                      }}
                        spacing={4}
                        sx={{
                          minHeight: 48,
                          justifyContent: openDrawer ? "initial" : "center",
                          px: 2.5,
                          color: "white",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: openDrawer ? 3 : "auto",
                            justifyContent: "center",
                            color: "white",
                          }}
                        >
                          <GroupIcon />
                        </ListItemIcon>
                        <ListItemText>
                          <Typography className="companySidebarTextSize" >
                            Ride Booking
                          </Typography>
                        </ListItemText>
                      </ListItemButton>
                    </NavLink>
                  </ListItem>
                {accountType === "Company" && role === "2" && (
                  <ListItem disablePadding sx={{ display: "block" }}>
                    <NavLink to={paths.company.myStaff} className="sidelink">
                      <ListItemButton
                        spacing={4}
                        sx={{
                          minHeight: 48,
                          justifyContent: openDrawer ? "initial" : "center",
                          px: 2.5,
                          color: "white",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: openDrawer ? 3 : "auto",
                            justifyContent: "center",
                            color: "white",
                          }}
                        >
                          <GroupIcon />
                        </ListItemIcon>
                        <ListItemText>
                          <Typography className="companySidebarTextSize" >
                            Employee Manager
                          </Typography>
                        </ListItemText>
                      </ListItemButton>
                    </NavLink>
                  </ListItem>
                )}
                {accountType === "Company" && role === "2" && (
                <ListItem disablePadding sx={{ display: "block" }}>
                  <NavLink to={paths.company.companyRegisterStaff} className="sidelink">
                    <ListItemButton
                      spacing={2}
                      sx={{
                        minHeight: 28,
                        justifyContent: openDrawer ? "initial" : "center",
                        px: 2.5,
                        color: "white",
                      }}
                      onClick={(e) => {
                        if (isProfileCompleted === false) {
                          e.preventDefault(); // stop any default behavior
                           if (!toast.isActive(toastId1)) {
                            toastId1 = toast.info(
                            "You cannot book right now because your profile is incomplete.",
                            { autoClose: 2500 }
                              );
                            }
                          return; // stop further execution
                        }
                         else if (isComissionNull === null || isComissionNull=="") {
                          e.preventDefault(); // stop any default behavior
                           if (!toast.isActive(toastId2)) {
                            toastId2 = toast.info(
                            "You cannot book right now because your commission has not yet been set. Contact customer support.",
                            { autoClose: 2500 }
                              );
                            }
                          return; // stop further execution
                        }
                        else if (bankInvoicelimit == null) {
                          e.preventDefault(); // stop any default behavior
                           if (!toast.isActive(toastId3)) {
                            toastId3= toast.info(
                            "You cannot add employee right now because your bank invoice limit has not yet been set.",
                            { autoClose: 2500 }
                              );
                            }
                          return; // stop further execution
                        }

                        // Otherwise, allow normal behavior (if you have any)
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: openDrawer ? 3 : "auto",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                        <GroupAddIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography className="companySidebarTextSize" >
                          Add Employee
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </NavLink>
                </ListItem>
                )}

                <ListItem disablePadding sx={{ display: "block" }}>
      
    </ListItem>
                {/* </List>


              <List> */}
                
                  <span>
                    

                    <ListItem disablePadding sx={{ display: "block" }}>
                      {/* <NavLink to={paths.company.editProfile} className="sidelink"> */}
                      <NavLink
                      to={
                        accountType === "Company" && role === "2"
                          ? paths.company.editProfile
                          : accountType === "Agent" && role === "2"
                          ? paths.businessAgent.editProfile
                          : "#" // fallback in case neither condition matches
                      }
                      className="sidelink"
                    >
                        <ListItemButton
                          spacing={4}
                          sx={{
                            minHeight: 48,
                            justifyContent: openDrawer ? "initial" : "center",
                            px: 2.5,
                            color: "white",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: openDrawer ? 3 : "auto",
                              justifyContent: "center",
                              color: "white",
                            }}
                          >
                            <EditIcon />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography className="companySidebarTextSize" >
                              Edit Profile
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </NavLink>
                    </ListItem>

                   

                    <ListItem disablePadding sx={{ display: "block" }}>
                      
                      <NavLink
                      to={
                        accountType === "Company" && role === "2"
                          ? paths.company.changePassword
                          : accountType === "Agent" && role === "2"
                          ? paths.businessAgent.changePassword
                          : "#" // fallback in case neither condition matches
                      }
                      className="sidelink"
                    >
                        <ListItemButton
                          spacing={4}
                          sx={{
                            minHeight: 48,
                            justifyContent: openDrawer ? "initial" : "center",
                            px: 2.5,
                            color: "white",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: openDrawer ? 3 : "auto",
                              justifyContent: "center",
                              color: "white",
                            }}
                          >
                            <LockIcon />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography className="companySidebarTextSize" >
                              Change Password
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </NavLink>
                    
                      {(role === "2") && (
                      <span>
                        <ListItem disablePadding sx={{ display: "block" }}>
                          <ListItemButton
                            spacing={4}
                            sx={{
                              minHeight: 48,
                              justifyContent: openDrawer ? "initial" : "center",
                              px: 2.5,
                              color: "white",
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 0,
                                mr: openDrawer ? 3 : "auto",
                                justifyContent: "center",
                                color: "white",
                              }}
                            >
                              <FunctionsIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Typography sx={{ marginInlineStart: "19px" }}>
                                <FormControl variant="standard" fullWidth>
                                  <Select
                                    size="small"
                                    sx={{
                                      color: "white",
                                      ".MuiSvgIcon-root": {
                                        color: "#fff",
                                      },
                                    }}
                                    value={invoiceHistory}
                                    onChange={handleSelectChange}
                                    renderValue={() => "Invoices"}
                                  >
                                    <MenuItem 
                                      value="Carrier Invoice"
                                      // onClick={() => navigate(paths.admin.invoiceHistory)}  start from here
                                    >
                                      Bank Invoice
                                    </MenuItem>

                                    <MenuItem
                                      value="Agent Invoice"
                                      onClick={() => handleMenuItemClick("Agent Invoice")}
                                    >
                                      Commission Invoice
                                    </MenuItem>

                                  </Select>
                                </FormControl>
                              </Typography>
                            </ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </span>

                    )}

                    </ListItem><ListItem disablePadding sx={{ display: "block" }}>
                      {/* <NavLink
                        to={paths.company.changePassword}
                        className="sidelink"
                      > */}
                      <NavLink
                      // to={
                      //   accountType === "Company" && role === "2"
                      //     ? paths.company.changePassword
                      //     : accountType === "Agent" && role === "2"
                      //     ? paths.businessAgent.changePassword
                      //     : "#" // fallback in case neither condition matches
                      // }
                      className="sidelink"
                    >
                        <ListItemButton
                          spacing={4}
                          sx={{
                            minHeight: 48,
                            justifyContent: openDrawer ? "initial" : "center",
                            px: 2.5,
                            color: "white",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: openDrawer ? 3 : "auto",
                              justifyContent: "center",
                              color: "white",
                            }}
                          >
                          <ReceiptLongIcon  sx={{ mr: 1 }} />

                          </ListItemIcon>
                          <ListItemText>
                            <Typography className="companySidebarTextSize" >
                              
                              Invoices
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </NavLink>
                    </ListItem>

                    <ListItem disablePadding sx={{ display: "block" }}>
                      {/* <NavLink
                        to={paths.company.changePassword}
                        className="sidelink"
                      > */}
                      <NavLink
                      to={
                        accountType === "Company" && role === "2"
                          ? paths.company.ReportsPage
                          : accountType === "Agent" && role === "2"
                          ? paths.businessAgent.ReportsPage
                          : "#" // fallback in case neither condition matches
                      }
                      className="sidelink"
                    >
                        <ListItemButton
                          spacing={4}
                          sx={{
                            minHeight: 48,
                            justifyContent: openDrawer ? "initial" : "center",
                            px: 2.5,
                            color: "white",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: openDrawer ? 3 : "auto",
                              justifyContent: "center",
                              color: "white",
                            }}
                          >
                          <DescriptionIcon  sx={{ mr: 1 }} />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography className="companySidebarTextSize" >
                              Reports
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </NavLink>
                    </ListItem>

                       <ListItem disablePadding sx={{ display: "block" }}>
                  <NavLink
                      to={
                        accountType === "Company" && role === "2"
                          ? paths.company.termsAndCondition
                          : accountType === "Agent" && role === "2"
                          ? paths.businessAgent.termsAndCondition
                          : "#" // fallback in case neither condition matches
                      }
                      className="sidelink"
                    >
                    <ListItemButton
                      spacing={4}
                      sx={{
                        minHeight: 48,
                        justifyContent: openDrawer ? "initial" : "center",
                        px: 2.5,
                        color: "white",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: openDrawer ? 3 : "auto",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                        <FunctionsIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography className="companySidebarTextSize" >
                          {" "}
                          Terms and Conditions
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </NavLink>
                </ListItem>
                  </span>
                
              </List>

              {/*<Button
                className="ms-4"
                sx={{
                  backgroundColor: "#FF4848",
                  borderRadius: "10px",
                  maxWidth: "190px",
                  ":hover": {
                    backgroundColor: "#FF2626",
                  },
                }}
                onClick={handleLogout}
                style={{ color: "white", fontWeight: "700" }}
              >
                <PowerSettingsNewIcon
                  className="me-1"
                  sx={{ height: "18px", width: "18px" }}
                />{" "}
                Log Out
              </Button>*/}

              <Button
                className="ms-4 companyLayoutLogoutButtonPadding"
                sx={{
                  backgroundColor: "#FF4848",
                  borderRadius: "10px",
                  maxWidth: "190px",
                  padding: {
                        //xs: "6px 11.5vw", // mobile (xs and below sm)
                        //sm: "6px 12vw", // tablets
                        md: "6px 4vw", // desktop
                      },
                  ":hover": {
                    backgroundColor: "#FF2626",
                  },
                }}
                onClick={handleLogout}
                style={{ color: "white", fontWeight: "700" }}
              >
                <PowerSettingsNewIcon
                  className="me-1 companySidebarTextSize"
                  sx={{ height: "18px", width: "18px" }}
                />{" "}
                Log Out
              </Button>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* 📱 Mobile Top Bar */}
      {isMobile && (
  <IconButton
    color="inherit"
    edge="start"
    onClick={handleDrawerToggle}
    sx={{
      position: "fixed",   // 🔑 keeps it floating
      top: 16,             // distance from top
      left: 16,            // distance from left
      zIndex: 2000,        // stays above content
      backgroundColor: "#1A1F23",
      color: "white",
      "&:hover": {
        backgroundColor: "#333",
      },
    }}
  >
    <MenuIcon />
  </IconButton>
)}

      {/* Sidebar Drawer */}
      <Box component="nav" aria-label="sidebar">
        {isMobile ? (
          // 📱 Mobile Drawer (ONLY temporary, overlays content)
          <MuiDrawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                backgroundColor: "#1A1F23",
                color: "white",
              },
            }}
          >
            {drawerContent}
          </MuiDrawer>
        ) : (
          // 🖥️ Desktop + iPad Drawer (permanent + collapsible)
          <Drawer
            variant="permanent"
            openDrawer={openDrawer}
            PaperProps={{
              sx: { backgroundColor: "#1A1F23", color: "white" },
            }}
          >
            {drawerContent}
          </Drawer>
        )}
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#F5F4F0",
          minHeight: "100vh",
        }}
      >
        {/* Add Toolbar spacing only on desktop, not mobile */}
        {!isMobile}
        <Outlet />
      </Box>
    </Box>
  );
}
